import { skills } from "@/data/portfolioData";
import { useReveal } from "@/hooks/useReveal";
import { SkillIcon } from "./icons/SkillIcons";

export function Skills() {
  const revealRef = useReveal();

  return (
    <section id="skills" className="relative z-[2] px-6 pb-[70px] pt-8 text-center md:px-14">
      <p className="mb-1.5 text-base font-bold text-teal">Battle-tested toolkit</p>
      <h2 className="mb-11 font-display text-[44px] text-ink">What I work with</h2>

      <div
        ref={revealRef}
        className="skills-grid grid grid-cols-1 gap-[22px] text-left sm:grid-cols-2 lg:grid-cols-4"
      >
        {skills.map((skill) => (
          <article
            key={skill.name}
            className="neo-card neo-card-hover rounded-2xl p-[26px]"
          >
            <div
              className={`mb-4 flex h-14 w-14 items-center justify-center rounded-xl border-3 border-ink ${skill.color}`}
            >
              <SkillIcon
                name={skill.icon}
                className={skill.iconLight ? "text-white" : "text-ink"}
              />
            </div>
            <h3 className="mb-2 font-display text-[19px] text-ink">{skill.name}</h3>
            <p className="m-0 text-[15px] leading-normal text-muted2">{skill.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
